import React, { Component } from 'react';
import axios from 'axios';
import pdfIcon from '../assets/images/pdfIconPNG.png';
import Global from '../Global';
const api = Global.api;

class Seguimiento extends Component {
    state = {
        sub_status: '',
        sub_status_render: ''
    }

    sub_id = React.createRef()

    componentWillMount() {
        console.log("Works")
    }

    searchSubmission = (e) => {
        e.preventDefault();

        axios.get(api + '/submissions/' + this.sub_id.current.value)
            .then((res) => {
                if (res.data.sub_status) {

                    this.setState({
                        sub_status: res.data.sub_status,
                        sub_status_render: this.renderSubStatus(true, res.data.sub_status, res.data.sub_resp)
                    })
                    console.log(this.state.sub_status)


                } else {
                    this.setState({
                        sub_status: '',
                        sub_status_render: this.renderSubStatus(false, '')
                    })
                }
            })
            .catch(() => {
                this.setState({
                    sub_status: '',
                    sub_status_render: this.renderSubStatus(false, '')
                })
            });
    }

    renderSubStatus = (exists = false, status, resp) => {
        if (exists) {
            if (status === 'ACEPTADA' || status === 'RECHAZADA' || status === 'INCORRECTA' || status === 'VALIDACIÓN DE DOCUMENTOS') {
                let docsRespList = resp.docs.map((doc) => {
                    if(doc === 'Sin Documento Anexado'){
                        return (
                            <b>No hay documentos de respuesta aún.</b>
                        )
                    }else{
                        return (
                            <a href={api + '/' + doc} donwload={doc.split('__')[1]} className="doc-image" target="blank" key={doc}>
                                <img src={pdfIcon} alt={""}/>
                                <p>{doc.split('__')[1]}</p>
                            </a>
                        )
                    }
                    
                })
                return (
                    <div className="col-6">
                        <br></br> <br></br>
                        <h6>El estado actual de tu solicitud es:</h6>
                        <h4><b>{status}</b></h4>
                        <br />
                        <h5>{resp.text}</h5>
                        <br/>
                        <h6>Descarga tus archivos de respuesta</h6>
                        <div className="docs-image-container">
                            {docsRespList}
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className="col-6">
                        <br></br> <br></br>
                        <h6>El estado actual de tu solicitud es:</h6>
                        <h5><b>{status}</b></h5>
                        <br />
                    </div>
                );
            }
        } else {
            return (
                <div className="col-6">
                    <br></br> <br></br>
                    <h6>¡Ingresa una clave de rastreo válida!</h6>
                </div>
            );
        }

    }

    render() {
        return (
            <div>
                <div className="solicitudes_container">
                    <div className="row">
                        <div className="col-lg-1 col-md-1"></div>
                        <div className="col-lg-8 col-md-8 col-sm-7 col-12">
                            <div className="row">
                                <div className="col-12">
                                    <span className="breadcrumbs"><a href="/solicitudes">Inicio </a> / <a href="/"> Rastrear mi solicitud</a></span>
                                </div>
                                <div className="col-12">
                                    <br />
                                    <h1>Rastrear mi solicitud</h1>
                                </div>
                                <div className="col-12">
                                    <span>Aquí podrás dar seguimiento a tu solicitud</span>
                                </div>
                                <div className="col-6">
                                    <br /><br />
                                    <h5>Ingresa tu clave de rastreo</h5>
                                    <div className="search-container">
                                        <input className="form-control" ref={this.sub_id}></input> &nbsp;
                                        <button className="btn btn-success" onClick={this.searchSubmission}>Rastrear</button>
                                    </div>
                                </div>
                                <div className="col-6"></div>
                                {this.state.sub_status_render}
                            </div>
                            <br />
                            <span>Cualquier duda o problema que tengas, puedes enviar un correo a <b>academica.fif@uaq.mx</b></span>
                        </div>
                        <div className="col-lg-2 col-md-2 col-sm-5"> </div>
                        <div className="col-lg-1 col-md-1"></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Seguimiento;